export default __webpack_public_path__ + "static/media/icons-home-navigation-black.09c4ca13.svg";